// Visual toast system - now provides actual UI notifications
import { useToast as useToastContext } from '../context/ToastContext';

// Hook-based toast for components that can use hooks
export const useToast = useToastContext;

// Fallback toast for non-React contexts (silent fallback)
const toast = {
  success: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  error: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  warning: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  info: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  loading: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  // For compatibility with react-hot-toast API
  default: (message, options = {}) => {
    // Silent fallback - no console logging
  },
  // Custom toast
  custom: (toastData) => {
    // Silent fallback - no console logging
  },
  // Dismiss specific toast
  dismiss: (id) => {
    // Silent fallback - no console logging
  },
  // Clear all toasts
  clear: () => {
    // Silent fallback - no console logging
  }
};

export default toast;
export { toast }; 